import { useState, useEffect } from 'react';

const axios = require('axios').default;

export default function useTransactions({ team, contact, csrfToken, enabled = true }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [count, setCount] = useState(null);
  const [lastDate, setLastDate] = useState('');
  const [range, setRange] = useState('all_time');
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalEntries, setTotalEntries] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (!enabled) return undefined;
    if (!team || !contact || !contact.id) return undefined;

    let ignore = false;
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        setError('');
        if (csrfToken) {
          axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
        }

        const response = await axios.get(
          `/teams/${team.id}/crm/fans/${contact.id}/transactions.json`,
          {
            params: {
              range,
              page,
              per_page: perPage,
            },
          },
        );
        if (ignore) return;
        const data = response.data || {};
        const txFromResponse = data.events || [];
        const pagination = data.pagination || {};

        setTransactions(txFromResponse);
        if (typeof data.event_count === 'number') {
          setCount(data.event_count);
        } else if (Array.isArray(txFromResponse)) {
          setCount(txFromResponse.length);
        }
        if (data.last_event_date) {
          setLastDate(data.last_event_date);
        } else {
          setLastDate('');
        }
        setTotalEntries(pagination.total_entries || txFromResponse.length || 0);
        setTotalPages(pagination.total_pages || 1);
      } catch (err) {
        if (!ignore) setError('Failed to load transactions');
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    fetchTransactions();
    return () => { ignore = true; };
  }, [team, contact, csrfToken, range, page, perPage, enabled]);

  return {
    transactions,
    loading,
    error,
    count,
    lastDate,
    range,
    setRange,
    page,
    setPage,
    perPage,
    totalEntries,
    totalPages,
  };
}
